import * as apiMethods from "@src/services";
import parseNetworkError from "@utils/parse-network-error";
// import keysToCamel from "@utils/keys-to-camel";
import getUtmsAndAdditionalData from "@utils/get-utms-and-additional-data";

export const SET_API_CALL_IN_PROGRESS = "SET_API_CALL_IN_PROGRESS";
export const SET_GENERAL_ERRORS = "SET_GENERAL_ERRORS";
export const SET_QUERIES = "SET_QUERIES";
export const CHANGE_SKU = "CHANGE_SKU";
export const CHANGE_LEADSOURCE = "CHANGE_LEADSOURCE";
export const CHANGE_SELLER = "CHANGE_SELLER";
export const CHANGE_MODE = "CHANGE_MODE";

export default {
  state: {
    isAPICallInProgress: false,
    generalErrors: [],
    query: {},
  },
  mutations: {
    [SET_API_CALL_IN_PROGRESS]: (state, status) => {
      state.isAPICallInProgress = status;
    },
    [SET_GENERAL_ERRORS]: (state, error) => {
      state.generalErrors.push(error);
    },
    [SET_QUERIES]: (state, values) => {
      state.query = { ...values };
    },
    [CHANGE_SKU]: (state, sku) => {
      state.query = { ...state.query, sku };
    },
    [CHANGE_LEADSOURCE]: (state, leadSource) => {
      state.query = { ...state.query, leadSource };
    },
    [CHANGE_SELLER]: (state, vendedor) => {
      state.query = { ...state.query, vendedor };
    },
    [CHANGE_MODE]: (state, sellerMode) => {
      state.sellerMode = sellerMode;
    },
  },
  actions: {
    /**
     * Dispatch AJAX calls
     * @param {String} entity e.g. `users`
     * @param {String} action method name eg. `getById`
     */
    async api({ commit }, { entity, action, payload = {}, query, params }) {
      try {
        const response = await apiMethods[entity][action]({
          payload,
          query,
          params,
        });
        return response;
      } catch (error) {
        const errorPayload = {
          [`${entity}_${action}_request`]: parseNetworkError(error),
        };
        commit(SET_GENERAL_ERRORS, errorPayload);
        commit(SET_API_CALL_IN_PROGRESS, false);
        throw new Error(error);
      }
    },
    setQueriesParams({ commit }, query) {
      commit(SET_QUERIES, query);
    },
    changeSku({ commit }, sku) {
      commit(CHANGE_SKU, sku);
    },
    changeLeadsource({ commit }, leadSource) {
      commit(CHANGE_LEADSOURCE, leadSource);
    },
    changeSeller({ commit }, seller) {
      commit(CHANGE_SELLER, seller);
    },
    changeSellerMode({ commit }, mode) {
      commit(CHANGE_MODE, mode);
    },
    clearSessionData: () => window.sessionStorage.clear(),
  },
  getters: {
    getQuery: state => {
      return getUtmsAndAdditionalData(state.query);
    },
    getRawQuery: state => {
      return state.query;
    },
    company: state => state.query.company || "revendavivo",
    currentSku: state => state.query.sku,
    segmento: state => state.query.type,
    sellerMode: state => state.sellerMode,
    leadSource: state => state.query.leadSource,
    isAPICallInProgress: state => state.isAPICallInProgress,
  },
};
